module.exports = __webpack_public_path__ + "img/Weapon_156.c3d451f1.png";